import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateLoyaltyEarningRulesRequest = {
    earningRules: '_loyaltyEarningRule',
};
var _bulkCreateLoyaltyEarningRulesResponse = {
    results: '_bulkLoyaltyEarningRuleResult',
};
var _bulkLoyaltyEarningRuleResult = { item: '_loyaltyEarningRule' };
var _createCustomLoyaltyEarningRuleRequest = {};
var _createCustomLoyaltyEarningRuleResponse = {
    earningRule: '_loyaltyEarningRule',
};
var _createLoyaltyEarningRuleRequest = { earningRule: '_loyaltyEarningRule' };
var _createLoyaltyEarningRuleResponse = {
    earningRule: '_loyaltyEarningRule',
};
var _deleteAutomationEarningRuleRequest = {};
var _deleteAutomationEarningRuleResponse = {};
var _deleteLoyaltyEarningRuleRequest = {};
var _deleteLoyaltyEarningRuleResponse = {};
var _getLoyaltyEarningRuleRequest = {};
var _getLoyaltyEarningRuleResponse = { earningRule: '_loyaltyEarningRule' };
var _invalidateEarningRuleCacheRequest = {};
var _invalidateEarningRuleCacheResponse = {};
var _listEarningRulesInTierRequest = {};
var _listEarningRulesInTierResponse = { earningRules: '_loyaltyEarningRule' };
var _listEarningRulesRequest = {};
var _listEarningRulesResponse = { earningRules: '_loyaltyEarningRule' };
var _loyaltyEarningRule = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _updateLoyaltyEarningRuleRequest = { earningRule: '_loyaltyEarningRule' };
var _updateLoyaltyEarningRuleResponse = {
    earningRule: '_loyaltyEarningRule',
};
function resolveComWixpressLoyaltyEarningruleLoyaltyEarningRulesUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/loyalty-earning-rules',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/loyalty-earning-rules',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/loyalty-earning-rules',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/loyalty-earning-rules',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/loyalty-earning-rules',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/loyalty-earning-rules',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/loyalty-earning-rules',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/loyalty-earning-rules',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/loyalty-earning-rules',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/loyalty-earning-rules',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/loyalty-earning-rules',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a non-automated earning rule.
 *
 * >**Note**: You can only create non-automated earning rules from a supported list.
 * For the supported list of services, see the Introduction.
 */
export function createLoyaltyEarningRule(payload) {
    var _a = serializer(_createLoyaltyEarningRuleRequest, { _loyaltyEarningRule: _loyaltyEarningRule }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createLoyaltyEarningRuleResponse, {
        _loyaltyEarningRule: _loyaltyEarningRule,
    }).fromJSON;
    function __createLoyaltyEarningRule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.loyalty_earning_rule',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.earningrule.LoyaltyEarningRules.CreateLoyaltyEarningRule',
            url: resolveComWixpressLoyaltyEarningruleLoyaltyEarningRulesUrl({
                protoPath: '/v1/earning-rules',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createLoyaltyEarningRule.fromReq = fromReq;
    __createLoyaltyEarningRule.__isAmbassador = true;
    return __createLoyaltyEarningRule;
}
/**
 * Creates multiple non-automated earning rules.
 *
 * >**Note**: You can only create non-automated earning rules from a supported list.
 * For the supported list of services, see the Introduction.
 */
export function bulkCreateLoyaltyEarningRules(payload) {
    var _a = serializer(_bulkCreateLoyaltyEarningRulesRequest, { _loyaltyEarningRule: _loyaltyEarningRule }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateLoyaltyEarningRulesResponse, { _bulkLoyaltyEarningRuleResult: _bulkLoyaltyEarningRuleResult, _loyaltyEarningRule: _loyaltyEarningRule }).fromJSON;
    function __bulkCreateLoyaltyEarningRules(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.loyalty_earning_rule',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.earningrule.LoyaltyEarningRules.BulkCreateLoyaltyEarningRules',
            url: resolveComWixpressLoyaltyEarningruleLoyaltyEarningRulesUrl({
                protoPath: '/v1/bulk/earning-rules/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateLoyaltyEarningRules.fromReq = fromReq;
    __bulkCreateLoyaltyEarningRules.__isAmbassador = true;
    return __bulkCreateLoyaltyEarningRules;
}
/**
 * Creates a custom automated earning rule.
 *
 * To learn more about the automated rules, see the Introduction.
 */
export function createCustomLoyaltyEarningRule(payload) {
    var _a = serializer(_createCustomLoyaltyEarningRuleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCustomLoyaltyEarningRuleResponse, { _loyaltyEarningRule: _loyaltyEarningRule }).fromJSON;
    function __createCustomLoyaltyEarningRule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.loyalty_earning_rule',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.earningrule.LoyaltyEarningRules.CreateCustomLoyaltyEarningRule',
            url: resolveComWixpressLoyaltyEarningruleLoyaltyEarningRulesUrl({
                protoPath: '/v1/earning-rules/custom',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCustomLoyaltyEarningRule.fromReq = fromReq;
    __createCustomLoyaltyEarningRule.__isAmbassador = true;
    return __createCustomLoyaltyEarningRule;
}
/**
 * Retrieves a specified non-automated earning rule.
 *
 * To retrieve both automated and non-automated earning rules, call List Earning Rules.
 */
export function getLoyaltyEarningRule(payload) {
    var _a = serializer(_getLoyaltyEarningRuleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getLoyaltyEarningRuleResponse, {
        _loyaltyEarningRule: _loyaltyEarningRule,
    }).fromJSON;
    function __getLoyaltyEarningRule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.loyalty_earning_rule',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.earningrule.LoyaltyEarningRules.GetLoyaltyEarningRule',
            url: resolveComWixpressLoyaltyEarningruleLoyaltyEarningRulesUrl({
                protoPath: '/v1/earning-rules/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getLoyaltyEarningRule.fromReq = fromReq;
    __getLoyaltyEarningRule.__isAmbassador = true;
    return __getLoyaltyEarningRule;
}
/**
 * Updates an earning rule.
 *
 * Supports partial updates.
 *
 * Revision number, which increments by 1 each time the earning rule is updated. To prevent conflicting changes,
 * the current `revision` must be passed when updating the earning rule.
 */
export function updateLoyaltyEarningRule(payload) {
    var _a = serializer(_updateLoyaltyEarningRuleRequest, { _loyaltyEarningRule: _loyaltyEarningRule }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateLoyaltyEarningRuleResponse, {
        _loyaltyEarningRule: _loyaltyEarningRule,
    }).fromJSON;
    function __updateLoyaltyEarningRule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.loyalty_earning_rule',
            method: 'PUT',
            methodFqn: 'com.wixpress.loyalty.earningrule.LoyaltyEarningRules.UpdateLoyaltyEarningRule',
            url: resolveComWixpressLoyaltyEarningruleLoyaltyEarningRulesUrl({
                protoPath: '/v1/earning-rules/{earningRule.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateLoyaltyEarningRule.fromReq = fromReq;
    __updateLoyaltyEarningRule.__isAmbassador = true;
    return __updateLoyaltyEarningRule;
}
/**
 * Deletes a non-automated earning rule.
 *
 * To delete an automated earning rule, call
 * Delete Automation Earning Rule.
 *
 * To update an earning rule's status instead of deleting it, call
 * Update Loyalty Earning Rule.
 */
export function deleteLoyaltyEarningRule(payload) {
    var _a = serializer(_deleteLoyaltyEarningRuleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteLoyaltyEarningRuleResponse, {}).fromJSON;
    function __deleteLoyaltyEarningRule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.loyalty_earning_rule',
            method: 'DELETE',
            methodFqn: 'com.wixpress.loyalty.earningrule.LoyaltyEarningRules.DeleteLoyaltyEarningRule',
            url: resolveComWixpressLoyaltyEarningruleLoyaltyEarningRulesUrl({
                protoPath: '/v1/earning-rules/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteLoyaltyEarningRule.fromReq = fromReq;
    __deleteLoyaltyEarningRule.__isAmbassador = true;
    return __deleteLoyaltyEarningRule;
}
/**
 * Deletes a custom automated earning rule.
 * Pre-installed automated rules can only be paused, not deleted.
 *
 * To update an earning rule's status instead of deleting it, call
 * Update Loyalty Earning Rule.
 *
 * To delete a non-automated earning rule, call
 * Delete Loyalty Earning Rule.
 */
export function deleteAutomationEarningRule(payload) {
    var _a = serializer(_deleteAutomationEarningRuleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteAutomationEarningRuleResponse, {}).fromJSON;
    function __deleteAutomationEarningRule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.loyalty_earning_rule',
            method: 'DELETE',
            methodFqn: 'com.wixpress.loyalty.earningrule.LoyaltyEarningRules.DeleteAutomationEarningRule',
            url: resolveComWixpressLoyaltyEarningruleLoyaltyEarningRulesUrl({
                protoPath: '/v1/automation-earning-rules/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteAutomationEarningRule.fromReq = fromReq;
    __deleteAutomationEarningRule.__isAmbassador = true;
    return __deleteAutomationEarningRule;
}
/**
 * Retrieves a list of earning rules.
 *
 * Returns both automated and non-automated earning rules.
 *
 * You can filter the results by `triggerAppId` or `triggerActivityType`.
 */
export function listEarningRules(payload) {
    var _a = serializer(_listEarningRulesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listEarningRulesResponse, {
        _loyaltyEarningRule: _loyaltyEarningRule,
    }).fromJSON;
    function __listEarningRules(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.loyalty_earning_rule',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.earningrule.LoyaltyEarningRules.ListEarningRules',
            url: resolveComWixpressLoyaltyEarningruleLoyaltyEarningRulesUrl({
                protoPath: '/v1/earning-rules/rules',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listEarningRules.fromReq = fromReq;
    __listEarningRules.__isAmbassador = true;
    return __listEarningRules;
}
export function listEarningRulesInTier(payload) {
    var _a = serializer(_listEarningRulesInTierRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listEarningRulesInTierResponse, {
        _loyaltyEarningRule: _loyaltyEarningRule,
    }).fromJSON;
    function __listEarningRulesInTier(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.loyalty_earning_rule',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.earningrule.LoyaltyEarningRules.ListEarningRulesInTier',
            url: resolveComWixpressLoyaltyEarningruleLoyaltyEarningRulesUrl({
                protoPath: '/v1/earning-rules-in-tier',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listEarningRulesInTier.fromReq = fromReq;
    __listEarningRulesInTier.__isAmbassador = true;
    return __listEarningRulesInTier;
}
export function invalidateEarningRuleCache(payload) {
    var _a = serializer(_invalidateEarningRuleCacheRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_invalidateEarningRuleCacheResponse, {}).fromJSON;
    function __invalidateEarningRuleCache(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.loyalty_earning_rule',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.earningrule.LoyaltyEarningRules.InvalidateEarningRuleCache',
            url: resolveComWixpressLoyaltyEarningruleLoyaltyEarningRulesUrl({
                protoPath: '/v1/earning-rules/cache-invalidate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __invalidateEarningRuleCache.fromReq = fromReq;
    __invalidateEarningRuleCache.__isAmbassador = true;
    return __invalidateEarningRuleCache;
}
//# sourceMappingURL=http.impl.js.map